<template>
    <div
        :class="
            'fixed bottom-4 left-4 z-50 rounded bg-primary-700 p-2 text-[12px] uppercase text-white drop-shadow' +
            ' ' +
            (showTimer ? '' : 'hidden')
        "
    >
        <div id="heartbeat">Timer: {{ this.timeTracked }}</div>
        <div id="counts">Study: {{ this.timeCountsAsStudying }}</div>
        <div class="">
            TOS:
            {{
                dayjs
                    .duration(runningTimers.time_on_site, "seconds")
                    .format("HH:mm:ss")
            }}
        </div>
        <div class="">
            TSS:
            {{
                dayjs
                    .duration(runningTimers.time_spent_studying, "seconds")
                    .format("HH:mm:ss")
            }}
        </div>
    </div>
</template>

<script>
export default {
    name: "StudentTimeTracker",
    props: {
        logEvery: {
            type: Number,
            default: 5,
        },
        updateEvery: {
            type: Number,
            default: window.heartbeatServerUpdateFrequency
                ? parseInt(window.heartbeatServerUpdateFrequency)
                : 60,
        },
    },
    data: function () {
        return {
            // showTimer: this.$page.props.env === 'local',
            showTimer: false,
            tracker: "emtprep_time_tracker",
            timeCountsAsStudying: false,
            timeTracked: 0,
            runningTimers: {
                time_on_site: this.$page.props.auth.user.time_on_site,
                time_spent_studying:
                    this.$page.props.auth.user.time_spent_studying,
            },
        };
    },
    methods: {
        startHeartbeat: function () {
            window.heartbeatInterval = setInterval(() => {
                this.logHeartbeat();
            }, this.logEvery * 1000);
        },
        logHeartbeat: function () {
            if (!window.userIdle && document.visibilityState === "visible") {
                this.timeTracked = this.timeTracked + this.logEvery;

                if (this.timeTracked >= this.updateEvery) {
                    // console.log("logHeartbeat " + new Date().toTimeString());
                    this.sendHeartbeat();
                }
            } else {
                this.timeTracked = 0;
            }
        },
        sendHeartbeat: function () {
            let vm = this;

            if (vm.timeTracked <= 3) {
                return;
            }

            axios
                .post("/heartbeat/", {
                    time_counts_as_studying: vm.timeCountsAsStudying,
                    time: vm.timeTracked,
                })
                .then(function (response) {
                    console.log({
                        TimeSent: vm.timeTracked,
                        CountsAsStudy: vm.timeCountsAsStudying,
                    });

                    vm.runningTimers = {
                        time_on_site:
                            vm.runningTimers.time_on_site + vm.timeTracked,
                        time_spent_studying:
                            vm.runningTimers.time_spent_studying +
                            (vm.timeCountsAsStudying ? vm.timeTracked : 0),
                    };

                    vm.timeTracked = 0;
                })
                .catch(function (error) {
                    console.log("Heartbeat: Failure", error);
                });
        },
        clearHeartbeat() {
            // console.log("clearing interval");
            clearInterval(window.heartbeatInterval);
        },
    },
    created() {
        let vm = this;

        let studyTimeRoutes = [
            "student.quiz.*",
            "student.flashcards.show-stack",
            "student.flashcards.create-stack",
            "student.flashcards.edit-stack",
            "student.worksheet.show-worksheet",
            "student.study-guides.show-study-guide",
            "student.videos.show-video",
            "student.live-event.show",
        ];

        studyTimeRoutes.forEach(function (studyTimeRoute) {
            if (route().current(studyTimeRoute)) {
                vm.timeCountsAsStudying = true;
            }
        });

        vm.startHeartbeat();
    },
    unmounted() {
        this.sendHeartbeat();
        this.clearHeartbeat();
        window.inertiaBeforeHeartbeatEvent = null;
    },
};
</script>
